
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/special-promotions",
      function () {
        return require("private-next-pages/special-promotions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/special-promotions"])
      });
    }
  